export default {
  data() {
    return {
      appRevCurrent: "0.3.1",
      appRevPrevious: "0.3.0",
      appDateCurrent: "13 / 10 / 2024",
      appDatePrevious: "7 / 09 / 2024",
      appEngCurrent: "", // doer
      appEngPrevious: "",
      appChkCurrent: "", // check
      appChkPrevious: "",
      appAppCurrent: "", // approver
      appAppPrevious: "",
      appComCurrent: "", // chaneg comment
      appComPrevious: ""
    };
  }
};
